export default "__VITE_ASSET__MDqF$rASXKs1Wjt7tI$3nQ__"